import { t as SandboxUserConfigLoader } from "./types-BP6ZEIjS.mjs";
import { Injectable } from "@gitlab/needle";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { ConfigService } from "@gitlab-org/config";
import * as os from "node:os";
import * as path from "node:path";
import { getDuoConfigFilePath } from "@gitlab-org/ai-configuration";
import { z } from "zod";
import * as fs from "node:fs";
//#region src/user_config/schema.ts
const SANDBOX_USER_CONFIG_FILENAME = "sandbox.json";
const filesystemSchema = z.object({
	allowRead: z.array(z.string()).optional(),
	denyRead: z.array(z.string()).optional(),
	allowWrite: z.array(z.string()).optional(),
	denyWrite: z.array(z.string()).optional()
}).strict().optional();
const networkSchema = z.object({
	allowedDomains: z.array(z.string()).optional(),
	deniedDomains: z.array(z.string()).optional()
}).strict().optional();
const srtSchema = z.object({
	enableWeakerNestedSandbox: z.boolean().optional(),
	ignoreViolations: z.record(z.string(), z.array(z.string())).optional()
}).strict().optional();
const SandboxUserConfigSchema = z.object({
	filesystem: filesystemSchema,
	network: networkSchema,
	srt: srtSchema
}).strict();
function summarizeZodIssues(error) {
	return error.issues.map((i) => `${i.path.length ? i.path.join(".") : "<root>"}: ${i.message}`).join("; ");
}
//#endregion
//#region src/user_config/user_config_loader.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DesktopSandboxUserCo;
(class {
	static {
		[_DesktopSandboxUserCo, _initClass] = _applyDecs(this, [Injectable(SandboxUserConfigLoader, [ConfigService, Logger])], []).c;
	}
	#configService;
	#logger;
	#snapshot;
	constructor(configService, logger) {
		this.#configService = configService;
		this.#logger = withPrefix(logger, "[SandboxUserConfig]");
	}
	getSnapshot() {
		if (!this.#snapshot) this.#snapshot = this.#load();
		return structuredClone(this.#snapshot);
	}
	#load() {
		const filePath = this.#resolvePath();
		if (!filePath) {
			this.#logger.debug("No sandbox config path resolved; using default sandbox policy");
			return { errors: [] };
		}
		return this.#readAndValidate(filePath);
	}
	#resolvePath() {
		const custom = this.#configService.get("duo.sandbox.userConfigPath");
		if (typeof custom === "string" && custom.length > 0) return custom.startsWith("~/") ? path.join(os.homedir(), custom.slice(2)) : custom;
		return getDuoConfigFilePath(SANDBOX_USER_CONFIG_FILENAME);
	}
	#readAndValidate(filePath) {
		let raw;
		try {
			raw = fs.readFileSync(filePath, "utf8");
		} catch (err) {
			const { code } = err;
			if (code === "ENOENT") {
				this.#logger.debug(`No config file at ${filePath}; using default sandbox policy`);
				return { errors: [] };
			}
			const message = err instanceof Error ? err.message : String(err);
			this.#logger.warn(`Failed to read config at ${filePath}: ${message}`);
			return { errors: [{
				path: filePath,
				issues: `read error: ${message}`
			}] };
		}
		let parsed;
		try {
			parsed = JSON.parse(raw);
		} catch (err) {
			const message = err instanceof Error ? err.message : String(err);
			this.#logger.warn(`Invalid JSON in config at ${filePath}: ${message}`);
			return { errors: [{
				path: filePath,
				issues: `invalid JSON: ${message}`
			}] };
		}
		const result = SandboxUserConfigSchema.safeParse(parsed);
		if (!result.success) {
			const issues = summarizeZodIssues(result.error);
			this.#logger.warn(`Schema validation failed for config at ${filePath}: ${issues}`);
			return { errors: [{
				path: filePath,
				issues
			}] };
		}
		this.#logger.debug(`Loaded config from ${filePath}`);
		return {
			config: result.data,
			errors: []
		};
	}
	static {
		_initClass();
	}
});
//#endregion
export { _DesktopSandboxUserCo as DesktopSandboxUserConfigLoader, SANDBOX_USER_CONFIG_FILENAME, SandboxUserConfigLoader, SandboxUserConfigSchema };

//# sourceMappingURL=user-config.mjs.map